// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PhoneCameraRouteImport } from './routes/phone-camera'
import { Route as LicenseRouteImport } from './routes/license'
import { Route as GithubRouteImport } from './routes/github'
import { Route as DiscordRouteImport } from './routes/discord'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DebugSentryRouteImport } from './routes/debug.sentry'
import { Route as AuthedSetupRouteImport } from './routes/_authed/setup'
import { Route as AuthedGameGameIdRouteImport } from './routes/_authed/game.$gameId'

const PhoneCameraRoute = PhoneCameraRouteImport.update({
            id: '/phone-camera',path: '/phone-camera',getParentRoute: () => rootRouteImport
          })
const LicenseRoute = LicenseRouteImport.update({
            id: '/license',path: '/license',getParentRoute: () => rootRouteImport
          })
const GithubRoute = GithubRouteImport.update({
            id: '/github',path: '/github',getParentRoute: () => rootRouteImport
          })
const DiscordRoute = DiscordRouteImport.update({
            id: '/discord',path: '/discord',getParentRoute: () => rootRouteImport
          })
const AuthedRoute = AuthedRouteImport.update({
            id: '/_authed',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const DebugSentryRoute = DebugSentryRouteImport.update({
            id: '/debug/sentry',path: '/debug/sentry',getParentRoute: () => rootRouteImport
          })
const AuthedSetupRoute = AuthedSetupRouteImport.update({
            id: '/setup',path: '/setup',getParentRoute: () => AuthedRoute
          })
const AuthedGameGameIdRoute = AuthedGameGameIdRouteImport.update({
            id: '/game/$gameId',path: '/game/$gameId',getParentRoute: () => AuthedRoute
          })





const AuthedRouteChildren = {
  AuthedSetupRoute: AuthedSetupRoute,AuthedGameGameIdRoute: AuthedGameGameIdRoute
}

const AuthedRouteWithChildren = AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthedRoute: AuthedRouteWithChildren,DiscordRoute: DiscordRoute,GithubRoute: GithubRoute,LicenseRoute: LicenseRoute,PhoneCameraRoute: PhoneCameraRoute,DebugSentryRoute: DebugSentryRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)